<template>
  <div class="header-container">
    <div class="container">
      <div class="row">
        <Header
          :notifyCategories="notifyCategories"/>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  name: 'HeaderDark',
  props: [
    'notifyCategories'
  ],
  components: {
    Header : () => import("@/components/Header/Header.vue")
  }
}
</script>

<style lang="scss" scoped>
@import '~sass/modules/components';

.vlt-header-dark {
  @extend .primary-bg.inverted;
}
.header-container{
  box-shadow: 0 1px 2px 0 rgba(0,0,0,0.15);
  // background-image: linear-gradient(194deg, #29487d 0%, #131d31 100%);
  background-image: linear-gradient(194deg, #2648A2 0%, #0F2F6E 100%);
  box-shadow: 0 1px 2px 0 rgba(0,0,0,0.15);
}
/* Extra small devices (phones, 600px and down) */
@media only screen and (max-width: 576px) {
  .header-container{
    // margin-bottom: 20px;
    .container{
      padding-left: 0px;
    }
  }
}
@media only screen and (min-width: 600px) and (max-width: 768px) {
  .header-container{
    // margin-bottom: 20px;
    .container{
      padding-left: 0px;
    }
  }
}
@media only screen and (min-width: 768px) and (max-width: 992px) {
  .header-container{
    // margin-bottom: 20px;
    .container{
      padding-left: 0px;
    }
  }
}
@media only screen and (min-width: 992px) {
  .header-container{
    // margin-bottom: 20px;
    .container{
      padding-left: 0px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Header/Dark/HeaderDark.vue